import { ReactNode } from 'react';
import ReactModal from 'react-modal';

import { Props } from 'lib/modal/simple-modal';
import { ModalBaseCss } from 'lib/modal/modal.constants';
import { grey1, grey2 } from 'approot/shared/styles/colours.style';
import { ACTIVITY_SHEET_CONTAINER } from './activity-sheet.utils';
import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/secondary-button.style';
import IconClose from 'approot/shared/icons/icon-close';
import { ACTIVITY_BUILDER_CLICK_CLEAR_IGNORE } from 'approot/activity-builder/activity-builder.constants';
import * as Styled from './activity-sheet.style';

const ActivitySheet = ({
  children,
  size,
  title,
  tabsContent,
  hasBackgroundColor,
  banner,
  customActions,
  onAfterOpen,
  onClose,
  ...rest
}: Props & {
  hasBackgroundColor?: boolean;
  tabsContent?: ReactNode;
  banner?: ReactNode;
  customActions?: ReactNode;
  onAfterOpen?: () => void;
}) => {
  return (
    <ReactModal
      isOpen
      {...rest}
      onRequestClose={onClose}
      onAfterOpen={onAfterOpen}
      style={{
        ...ModalBaseCss,
        content: {
          ...ModalBaseCss.content,
          display: 'flex',
          overflow: 'hidden',
          flexDirection: 'column',
          inset: '0',
          maxWidth: '100%',
          height: '100vh',
          padding:
            '4px calc(4px + env(safe-area-inset-left)) 0 calc(4px + env(safe-area-inset-left))',
        },
      }}
      contentLabel={title}
      bodyOpenClassName={`${ACTIVITY_BUILDER_CLICK_CLEAR_IGNORE} ReactModal__Body--open`}
    >
      {customActions && (
        <Styled.ActivitySheetCustomActions>
          {customActions}
        </Styled.ActivitySheetCustomActions>
      )}
      {banner && banner}

      {onClose && (
        <ActivitySheetCloseButton
          banner={banner}
          title={title}
          onClose={onClose}
        />
      )}

      <Styled.ActivitySheetContent
        data-selector="activity-sheet-content"
        $hasBanner={!!banner}
      >
        {tabsContent}
        <Styled.ActivitySheetScrollable
          data-selector="activity-sheet-container"
          id={ACTIVITY_SHEET_CONTAINER}
          $backgroundColor={hasBackgroundColor ? grey2 : grey1}
        >
          {children}
        </Styled.ActivitySheetScrollable>
      </Styled.ActivitySheetContent>
    </ReactModal>
  );
};

export default ActivitySheet;

export const ActivitySheetCloseButton = ({
  banner,
  title,
  onClose,
}: {
  banner?: ReactNode;
  title: string;
  onClose: () => void;
}) => {
  return (
    <Styled.ActivitySheetCloseButton $hasBanner={!!banner}>
      <SecondaryButtonIcon
        type="button"
        aria-label={`Close ${title}`}
        data-selector="close-modal"
        $borderRadius={40}
        onClick={onClose}
      >
        <IconClose width={16} height={16} />
      </SecondaryButtonIcon>
    </Styled.ActivitySheetCloseButton>
  );
};
